import DEFAULT_IMAGEM_PERFIL from './defaultImagemPerfil';
import LIGHT_THEME from './lightTheme';
import DARK_THEME from './darkTheme';
import LOGO_DESENVOLVA from './logoDesenvolva';
import LOGO_UFC from './logoUfc';

export {
  DEFAULT_IMAGEM_PERFIL, LIGHT_THEME, DARK_THEME, LOGO_DESENVOLVA, LOGO_UFC,
};
